export const blogPosts = [
  {
    slug: 'writing-clean-apis',
    title: '',
    date: '01 May 2026',
    readTime: '6 min',
    category: 'Backend',
    excerpt: '',
    markdownPath: '/content/posts/writing-clean-apis.md',
  },
  {
    slug: 'system-design-notes',
    title: '',
    date: '28 April 2026',
    readTime: '7 min',
    category: 'Architecture',
    excerpt: '',
    markdownPath: '/content/posts/system-design-notes.md',
  },
];

export const blogCategories = [...new Set(blogPosts.map((post) => post.category))];

export const getPostBySlug = (slug) => blogPosts.find((post) => post.slug === slug);

